import { Avatar, Divider, Grid, ButtonBase } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import { AutorenewRounded, CheckCircleRounded, CloseRounded, DateRangeRounded, DescriptionRounded, EditRounded, EmojiEventsRounded, EuroRounded, FolderRounded, LocalAirportRounded, MenuBookRounded, PeopleAltRounded, ReceiptRounded, RoomRounded, RouterRounded, SchoolRounded, WorkRounded } from '@material-ui/icons';
import { getInfosDashboard, deleteRelation } from '@webapps/business';
import { useQuery, useMutation } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal from 'components/Modal';
import { useEffect, useState } from 'react';
import { FormattedDate } from 'react-intl';
import EditFormation from './EditFormation';
import TrainingsCardSkeleton from './TrainingsCardSkeleton';

import HourglassHalf from 'components/Icons/HourglassHalf';

const TrainingsCard = ({ info, refetch, isLoadingInfo = false }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [open, setOpen] = useState(false);
  const [stepModal, setStepModal] = useState(0);

  const { data: dashboardInfo = {} } = useQuery(getInfosDashboard, {
    key: ['infoDashboardSchool', info?.training?.school?.id],
    variables: { id: info?.training?.school?.id },
    enabled: !isLoadingInfo,
  });

  const profileImage = dashboardInfo?.profile?.profileImageUrl || info?.profileImageUrl;

  const {
    isLoading,
    isSuccess,
    isError,
    mutateAsync: mutateDeleteRelation,
  } = useMutation(deleteRelation);

  useEffect(() => {
    if (isLoadingInfo) return;

    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Relation supprimée avec succès',
        autoDismiss: true,
      });
      refetch();
      setOpen(false);
    } else if (isError) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la suppression de la relation',
        autoDismiss: true,
      });
    }
  }, [isSuccess, isError, isLoadingInfo]);

  if (isLoadingInfo) {
    return <TrainingsCardSkeleton />;
  }

  return (
    <div className={classes.container}>
      <CardContent className={css({ textAlign: 'center', padding: spacing(0, 0, 2.5, 0) })}>
        <div className={css({ display: 'flex', justifyContent: 'space-between' })}>
          <div className={classes.photo}>
            <div>
              {profileImage ? (
                <Avatar className={classes.avatar} src={profileImage} />
              ) : (
                <Avatar className={classes.avatar}>
                  {info.training?.school?.name?.substr(0, 1)}
                </Avatar>
              )}
            </div>
            <div>
              <div className={cx(global.title, classes.name, css({ marginBottom: "10px" }))}>
                {info?.training?.school?.name}
              </div>
              <div className={cx(classes.name, global.infoText, global.frac)} >
                <RoomRounded className={global.smallIcon} />
                <div>{info?.training?.school?.address?.cityCode} {info?.training?.school?.address?.city}</div>
              </div>
            </div>
          </div>
          <div>
            <ButtonBase onClick={() => setOpen(true)} className={global.buttonBase}>
              <EditRounded className={global.buttonIcon} />
            </ButtonBase>
          </div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <WorkRounded className={global.infoIcon} />
          <div>{`${info?.training?.label}`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <DescriptionRounded className={global.infoIcon} />
          <div>{`${info?.training?.trainingType?.label}`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <SchoolRounded className={global.infoIcon} />
          <div>{`${info?.training?.degree?.label} (Code diplôme ${info?.training?.diplomaCode})`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <EmojiEventsRounded className={global.infoIcon} />
          <div>{`RNCP ${info?.training?.rncp}`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <MenuBookRounded className={global.infoIcon} />
          <div>{`${info?.training?.domain?.label}`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <DateRangeRounded className={global.infoIcon} />
          <FormattedDate
            day="numeric"
            month="numeric"
            value={info?.training?.openingDate}
            year="numeric"
          />{' '}
          au{' '}
          <FormattedDate
            day="numeric"
            month="numeric"
            value={info?.training?.closingDate}
            year="numeric"
          />
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <HourglassHalf className={global.infoIcon} />
          <div>{`${info?.training?.trainingDuration} heures de formation`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <AutorenewRounded className={cx(global.infoIcon)} />
          <div>{info?.training?.rythmAlternance}</div>
        </div>
        <Divider className={classes.divider} />
        <div className={cx(global.infoText, classes.address)}>
          <EuroRounded className={global.infoIcon} />
          <div>{`Coût total pédagogie CFA : ${info?.training?.trainingTotalCost ? info?.training?.trainingTotalCost + '€' : "Non renseigné"}`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <LocalAirportRounded className={global.infoIcon} />
          <div>{`Mobilité internationale : ${info?.training?.internationalMobility ? "Oui" : "Non"}`}</div>
        </div>
        <Divider className={classes.divider} />
        <div className={cx(global.infoText, classes.address)}>
          <PeopleAltRounded className={global.infoIcon} />
          <div>{`${info?.totalStudents} Apprenants`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <CheckCircleRounded className={global.infoIcon} />
          <div>{`${info?.totalStudentsBusiness} Apprenants en entreprise`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <DescriptionRounded className={global.infoIcon} />
          <div>{`${info?.totalContractToSend} Contrat à envoyer`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <DescriptionRounded className={global.infoIcon} />
          <div>{`${info?.totalContractAwaiting} Contrat en attente des autres parties`}</div>
        </div>
        <Divider className={classes.divider} />
        <div className={cx(global.infoText, classes.address)}>
          <FolderRounded className={global.infoIcon} />
          <div>{`${info?.totalOpcoRecords} Dossiers OPCO`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <ReceiptRounded className={global.infoIcon} />
          <div>{`${info?.totalBillings} Factures`}</div>
        </div>
      </CardContent>
      <div className={classes.buttons}>
        {info?.training?.cfaCompliant ? (
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                fullWidth
                onClick={() => console.log("dossier")}
                className={global.greyButton}
                variant="outlined"
              >
                Dossiers OPCO
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                onClick={() => console.log("compta")}
                className={global.greyButton}
                variant="outlined"
              >
                Comptabilité
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Button
            onClick={() => setOpen(true)}
            className={global.lightBlueButton}
            variant="outlined"
          >
            Compléter les données manquantes
          </Button>
        )}
      </div>
      <Modal
        nbStep={5}
        onCancel={() => setOpen(false)}
        open={open}
        step={stepModal}
        subTitle="Ajoutez des informations"
        title="Modifiez l'offre de formation"
      >
        <EditFormation
          formation={info?.training}
          onChangeStepModal={setStepModal}
          onClose={() => setOpen(false)}
          refetchFormation={refetch}
        />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: "white",
    borderRadius: 16,
    padding: spacing(2.5),
  },
  buttonsContainer: {
    display: 'flex',
    columnGap: 10,
  },
  name: {
    marginLeft: spacing(2),
    display: 'flex',
    textAlign: 'start',
    fontFamily: 'Montserrat',
    wordBreak: 'break-all',
  },
  divider: {
    margin: "8px 0px",
  },
  address: {
    display: 'flex',
    marginTop: spacing(0.5),
    textAlign: 'start',
    alignItems: 'center',
  },
  avatar: {
    height: 60,
    width: 60,
    border: '1px solid #C0D9FF',
  },
  photo: {
    marginBottom: spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    rowGap: 10,
  },
});

export default TrainingsCard;
